<template>
    <div class="mainContent">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />

        <!-- 簡述 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="station.title" :showMore="false"></PwaTitle>
            <div class="global-descript" style="padding-bottom: 20px;">{{ station.descript }}</div>
        </b-container>

        <!-- 條件選單 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="agri_weath.text" :showMore="false"></PwaTitle>
            <div class="w3-row">
                <!-- 縣市 -->
                <div class="w3-col w3-container m4 l4">
                    <p>
                        <label class="global-descript">{{ agri_weath.input.city.text }}</label>
                        <v-select class="global-descript" v-model="agri_weath.input.city.value" :options="agri_weath.input.city.list" :reduce="(option) => option.value" label="text"></v-select>
                    </p>
                </div>
                <!-- 鄉鎮市區 -->
                <div class="w3-col w3-container m4 l4">
                    <p>
                        <label class="global-descript">{{ agri_weath.input.town.text }}</label>
                        <v-select class="global-descript" v-model="agri_weath.input.town.value" :options="agri_weath.input.town.list" :reduce="(option) => option.value" label="text"></v-select>
                    </p>
                </div>
                <!-- 地址 -->
                <div class="w3-col w3-container m4 l4">
                    <p class="global-descript">
                        <label class="global-descript">{{ agri_weath.input.addr.text }}</label><br />
                        {{ agri_weath.input.addr.value }}
                    </p>
                </div>
            </div>
        </b-container>

        <!-- 天氣資訊 -->
        <b-container>
            <!-- 溫度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ agri_weath.info.c_t.text }}</li>
                    <li class="global-descript"><b>{{ agri_weath.info.c_t.value }}°C</b></li>
                </ul>
            </div>
            <!-- 體感溫度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ agri_weath.info.c_at.text }}</li>
                    <li class="global-descript"><b>{{ agri_weath.info.c_at.value }}°C</b></li>
                </ul>
            </div>
            <!-- 相對溼度 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ agri_weath.info.rh.text }}</li>
                    <li class="global-descript"><b>{{ agri_weath.info.rh.value }}%</b></li>
                </ul>
            </div>
            <!-- 時雨量 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ agri_weath.info.rain.text }}</li>
                    <li class="global-descript"><b>{{ agri_weath.info.rain.value }}mm</b></li>
                </ul>
            </div>
            <!-- 日出時間 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ agri_weath.info.sunrise.text }}</li>
                    <li class="global-descript"><b>{{ agri_weath.info.sunrise.value }}</b></li>
                </ul>
            </div>
            <!-- 日落時間 -->
            <div class="w3-col w3-margin-bottom" style="width:33.33%">
                <ul class="w3-ul w3-border w3-center w3-hover-shadow">
                    <li class="global-descript">{{ agri_weath.info.sunset.text }}</li>
                    <li class="global-descript"><b>{{ agri_weath.info.sunset.value }}</b></li>
                </ul>
            </div>
            <div>&nbsp;</div>

        </b-container>

        <!-- 72小時預報 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="agri_weath.hr72.text" :showMore="false"></PwaTitle>
            <!-- 圖表 -->
            <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                <div id="chart_intelligence_agri_hr72" class="forecast_line_chart" style="height: 250px;width: 100%; background:#F9F9F9; min-width: 1200px;"></div>
            </div>
            <!-- 表格 -->
            <div class="w3-row global-descript" style="overflow-x: auto; overflow-y: hidden;">
                <table data-v-16991ed1="" class="table table-striped table-center weath-table" v-html="agri_weath.hr72.html"></table>
            </div>
            <div>&nbsp;</div>
        </b-container>

        <!-- 一周溫度曲線 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="agri_weath.week.text" :showMore="false"></PwaTitle>
            <!-- 圖表 -->
            <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                <div id="chart_intelligence_agri_week_t" class="forecast_line_chart" style="height: 250px;width: 100%; background:#F9F9F9; min-width: 900px;"></div>
            </div>
            <!-- 表格 -->
            <div class="w3-row global-descript" style="overflow-x: auto; overflow-y: hidden;">
                <table data-v-16991ed1="" class="table table-striped table-center weath-table" v-html="agri_weath.week.html"></table>
            </div>
            <div>&nbsp;</div>
        </b-container>

        <!-- 一周體感溫度曲線 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="agri_weath.week.text2" :showMore="false"></PwaTitle>
            <!-- 圖表 -->
            <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;">
                <div id="chart_intelligence_agri_week_at" class="forecast_line_chart" style="height: 250px;width: 100%; background:#F9F9F9; min-width: 900px;"></div>
            </div>
            <!-- 表格 -->
            <div class="w3-row global-descript" style="overflow-x: auto; overflow-y: hidden;">
                <table data-v-16991ed1="" class="table table-striped table-center weath-table" v-html="agri_weath.week.html"></table>
            </div>
            <div>&nbsp;</div>
        </b-container>

        <!-- 天氣圖資 -->
        <b-container>
            <!-- 標題 -->
            <PwaTitle :textTitle="agri_weath.input.img.text" :showMore="false"></PwaTitle>
            <v-select class="global-descript" v-model="agri_weath.input.img.value" :options="agri_weath.input.img.list" :reduce="(option) => option.value" label="text" style="margin-bottom: 5px;"></v-select>
            <div class="w3-row" style="text-align:center;">
                <img style="width:100%;max-width: 800px;" :src="agri_weath.input.img.src" class="img-responsive img_center" data-title=">300mm" data-toggle="modal" data-target="#image_modal" title="點擊可放大檢視">
            </div>
        </b-container>

    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    mounted(){
        this.getInfoAgriWeathTown();
        this.getInfoAgriWeathInfo();
        this.getInfoAgriWeathChartHr72();
        this.getInfoAgriWeathChartWeek(); 
    },
    created() {
        window.vue = this;
        if(!window.checkLogin()){ window.setPage("login");}               
    },  
    components: {
        Header,
        PwaTitle
    },
    data(){
        return {
            title: "農業氣象服務專區",
            
            //中央氣象觀測站說明
            station:{
                title:"中央氣象觀測站資料整合",
                descript:"本專區即時介接中央氣象局觀測資料，提供雲林縣各鄉鎮之溫度、降雨量、風速風向、日照時數等氣象資訊，使用者可快速掌握各地即時天氣與未來幾日的氣象預報，以利農事安排與防災規劃。"
            },

            //農業天氣資訊
            agri_weath:{
                id:"agri_weath",
                text:"農業天氣資訊",
                url:"",
                //表單物件
                input:{
                    //縣市
                    city:{
                        text:"縣市",
                        value:"10009",
                        placeholder:"請選擇縣市",
                        list:[
                            {value:"63",text:"臺北市"},
                            {value:"65",text:"新北市"},
                            {value:"68",text:"桃園市"},
                            {value:"10004",text:"新竹縣"},
                            {value:"10005",text:"苗栗縣"},
                            {value:"66",text:"臺中市"},
                            {value:"10007",text:"彰化縣"},
                            {value:"10008",text:"南投縣"},
                            {value:"10009",text:"雲林縣"},
                            {value:"10020",text:"嘉義市"},
                            {value:"10010",text:"嘉義縣"},
                            {value:"67",text:"臺南市"},
                            {value:"64",text:"高雄市"},
                            {value:"10013",text:"屏東縣"},
                            {value:"10002",text:"宜蘭縣"},
                            {value:"10015",text:"花蓮縣"},
                            {value:"10014",text:"臺東縣"},
                            {value:"10016",text:"澎湖縣"}
                        ],
                    },
                    //鄉鎮市區
                    town:{
                        text:"鄉鎮市區",
                        value:"",
                        placeholder:"請選擇鄉鎮市區",
                        list:[],
                        Info_Agri:[],
                        GT:[],
                        GT_Time:[],
                        Position3h:{},
                        Date_3hr:{},
                        Time_3hr:{},
                        TempArray_3hr:{},
                    },
                    //地址
                    addr:{
                        text:"地址",
                        value:""
                    },
                    //天氣圖資
                    img:{
                        text:"天氣圖資",
                        value:"satellite",
                        src:"https://www.cwa.gov.tw/Data/satellite/LCC_TRGB_1000/LCC_TRGB_1000.jpg",
                        placeholder:"請選擇天氣圖資",
                        list:[
                            {value:"satellite",text:"衛星雲圖"},
                            {value:"dish",text:"雷達回波"},
                            {value:"raining",text:"累積雨量"},
                            {value:"temperature",text:"溫度分布"},
                            {value:"lightning",text:"即時閃電"},
                            {value:"uv",text:"紫外線"}
                        ],
                    },
                }, 
                //當日天氣資訊
                info:{
                    //是否有結果
                    is_result:false,
                    //溫度
                    c_t:{
                        text:"溫度",
                        value:0
                    },
                    //體感溫度
                    c_at:{
                        text:"體感溫度",
                        value:0
                    },
                    //時雨量
                    rain:{
                        text:"時雨量",
                        value:0
                    },
                    //相對溼度
                    rh:{
                        text:"相對溼度",
                        value:0
                    },
                    //日出時間
                    sunrise:{
                        text:"日出時間",
                        value:0
                    },
                    //日落時間
                    sunset:{
                        text:"日落時間",
                        value:0
                    },
                },
                //72小時天氣預報詳細資料
                hr72:{
                    text:"72小時預報",
                    html:""
                },
                //一周預報
                week:{
                    text:"一周溫度曲線",
                    text2:"一周體感溫度曲線",
                    html:""
                }
            },

            //api 取得中央氣象屬(鄉鎮市區及作物)
            apiGetInfoAgriWeathTown: (data) => this.userRequest.get("API/Default/GetInfoAgriWeathTown", data),

            //api 取得中央氣象屬(鄉鎮市區及作物)
            apiGetInfoAgriWeathTownAddress: (data) => this.userRequest.post("API/Default/GetInfoAgriWeathTownAddress", data),

            //api 取得中央氣象屬(鄉鎮市區及作物)(溫度、體感溫度、相對濕度、時雨量、日出、日落)
            apiGetInfoAgriWeathInfo: (data) => this.userRequest.get("API/Default/GetInfoAgriWeathInfo", data),

            //api 取得中央氣象屬(鄉鎮市區及作物)(72小時溫度曲線圖表)
            apiGetInfoAgriWeathChartHr72: (data) => this.userRequest.get("API/Default/GetInfoAgriWeathChartHr72", data),

            //api 取得中央氣象屬(鄉鎮市區及作物)(72小時溫度表格)
            apiGetInfoAgriWeathTableHr72: (data) => this.userRequest.post("API/Default/GetInfoAgriWeathTableHr72", data),

            //api 取得中央氣象屬(鄉鎮市區及作物)(一周預報溫度曲線)
            apiGetInfoAgriWeathChartWeek: (data) => this.userRequest.get("API/Default/GetInfoAgriWeathChartWeek", data),

            //api 取得中央氣象屬(鄉鎮市區及作物)(一周預報表格)
            apiGetInfoAgriWeathTableWeek: (data) => this.userRequest.post("API/Default/GetInfoAgriWeathTableWeek", data),
    
        }
    },
    watch: {

        //農業天氣資訊-縣市
        "agri_weath.input.city.value":function(val)
        {
            console.log(val);
            this.setInfoAgriWeathTown();
        },
        //農業天氣資訊-鄉鎮市區
        "agri_weath.input.town.value":function(val)
        {
            console.log(val);
            this.setInfoAgriWeathInfo();
            this.getInfoAgriWeathTownAddress();
            this.getInfoAgriWeathChartHr72();
            this.getInfoAgriWeathTableHr72();
            this.getInfoAgriWeathChartWeek(); 
            this.getInfoAgriWeathTableWeek(); 
        },
        //農業天氣資訊-天氣圖資
        "agri_weath.input.img.value":function(val)
        {
            switch (val) {
            case "satellite":
                //衛星雲圖
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/satellite/LCC_TRGB_1000/LCC_TRGB_1000.jpg";
                break;
            case "dish":
                //雷達回波
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/radar/CV1_TW_1000.png";
                break;
            case "raining":
                //累積雨量
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/rainfall/QZJ.jpg";
                break;
            case "temperature":
                //溫度分布
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/temperature/temp.jpg";
                break;
            case "lightning":
                //即時閃電
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/lightning/lightning_s.jpg";
                break;
            case "uv":
                //紫外線
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/UVI/UVI.png";
                break;
            default:
                this.agri_weath.input.img.src = "https://www.cwa.gov.tw/Data/satellite/LCC_TRGB_1000/LCC_TRGB_1000.jpg";
            }
        },
    },
    methods: {

        //取得中央氣象屬(鄉鎮市區及作物)
        getInfoAgriWeathTown(data) {
        this.apiGetInfoAgriWeathTown(data)
            .then((res) => {
                eval(res.data);
                this.setInfoAgriWeathTown();
                console.log(this.agri_weath.input.town.Info_Agri);
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //取得中央氣象屬(鄉鎮市區及作物)(地址)
        getInfoAgriWeathTownAddress() {
            
            if(this.select == "agri_weath")
            {
                this.addUserActionLog({

                    TokenID:sessionStorage.getItem("TokenID"),
                    WebPage:"農業情報站",
                    WebAction:"提交",
                    ActionMemo:"農業天氣資訊",
                    RequestData:JSON.stringify({

                        PID:this.agri_weath.input.town.value
                    })
                });
            }

            this.apiGetInfoAgriWeathTownAddress({
                PID:this.agri_weath.input.town.value,
            })
            .then((res) => {
                //eval(res.data);
                var address = res.data;
                address = address.split("<p>")[1]; 
                address = address.split("</p>")[0]; 
                address = address.replaceAll("地址：","");
                this.agri_weath.input.addr.value = address;
            })
            .catch((err) => {
                console.log(err);
            });
        },
        
        //取得中央氣象屬(鄉鎮市區及作物)(溫度、體感溫度、相對濕度、時雨量、日出、日落)
        getInfoAgriWeathInfo(data) {
        this.apiGetInfoAgriWeathInfo(data)
            .then((res) => {
                eval(res.data);
                console.log(this.agri_weath.input.town.GT);
                console.log(this.agri_weath.input.town.GT_Time);
                this.agri_weath.input.town.GT_Time.C = this.agri_weath.input.town.GT_Time.C.replaceAll("<br>","");
                this.setInfoAgriWeathInfo();
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //取得中央氣象屬(鄉鎮市區及作物)(72小時溫度曲線圖表)
        getInfoAgriWeathChartHr72(data) {
        this.apiGetInfoAgriWeathChartHr72(data)
            .then((res) => {
                eval(res.data);
                this.setInfoAgriWeathChartHr72();
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //取得中央氣象屬(鄉鎮市區及作物)(72小時溫度表格)
        getInfoAgriWeathTableHr72() {
        this.apiGetInfoAgriWeathTableHr72({
                PID:this.agri_weath.input.town.value,
            })
            .then((res) => {
                this.agri_weath.hr72.html = res.data;
            })
            .catch((err) => {
                console.log(err);
            });
        },
        
        //取得中央氣象屬(鄉鎮市區及作物)(一周預報溫度曲線)
        getInfoAgriWeathChartWeek(data) {
        this.apiGetInfoAgriWeathChartWeek(data)
            .then((res) => {

                eval(res.data);
                console.log(this.agri_weath.input.town.Time_Week);
                console.log(this.agri_weath.input.town.TempArray_Week);

                console.log(this.agri_weath.input.town.TempArray_Week[this.agri_weath.input.town.value].C.T);
                console.log(this.agri_weath.input.town.TempArray_Week[this.agri_weath.input.town.value].C.AT);

                for(var i=0 ; i < this.agri_weath.input.town.Time_Week.C.length ; i++)
                {
                    var item = this.agri_weath.input.town.Time_Week.C[i];
                    item = item.replaceAll("<span style=\"color:#ea1904;\">","");
                    item = item.replaceAll("</span>","");
                    item = item.replaceAll("<br>"," ");
                    this.agri_weath.input.town.Time_Week.C[i] = item;
                }
                this.setInfoAgriWeathChartWeekT();
                this.setInfoAgriWeathChartWeekAT();
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //取得中央氣象屬(鄉鎮市區及作物)(一周預報表格)
        getInfoAgriWeathTableWeek() {
        this.apiGetInfoAgriWeathTableWeek({
                PID:this.agri_weath.input.town.value,
            })
            .then((res) => {
                this.agri_weath.week.html = res.data;
                console.log(this.agri_weath.week.html)
            })
            .catch((err) => {
                console.log(err);
            });
        },

        //設定農業天氣資訊-鄉鎮市區
        setInfoAgriWeathTown(){

            this.agri_weath.input.town.list = [];
            for(var i=0 ; i<this.agri_weath.input.town.Info_Agri.length ; i++)
            {
                var item = this.agri_weath.input.town.Info_Agri[i];
                if(item.CID == this.agri_weath.input.city.value)
                {
                    this.agri_weath.input.town.list.push({text:item.Name.C,value:item.PID});
                }
            }

            if(this.agri_weath.input.town.list.length > 0){ 
                this.agri_weath.input.town.value = this.agri_weath.input.town.list[0].value;
                this.getInfoAgriWeathTownAddress();
                this.setInfoAgriWeathInfo(); 
                this.getInfoAgriWeathTableHr72();    
                this.getInfoAgriWeathTableWeek(); 
            } 
                        
        },
        //設定農業天氣資訊-鄉鎮市區(天氣資訊)
        setInfoAgriWeathInfo(){

            this.agri_weath.info.c_t.value = "";        
            this.agri_weath.info.c_at.value = ""; 
            this.agri_weath.info.rain.value = ""; 
            this.agri_weath.info.rh.value = ""; 
            this.agri_weath.info.sunrise.value = ""; 
            this.agri_weath.info.sunset.value = ""; 

            if( this.agri_weath.input.town.GT != null &&
                this.agri_weath.input.town.value != null && this.agri_weath.input.town.value != "")
            {
                this.agri_weath.info.c_t.value = this.agri_weath.input.town.GT[this.agri_weath.input.town.value].C_T;        
                this.agri_weath.info.c_at.value = this.agri_weath.input.town.GT[this.agri_weath.input.town.value].C_AT;
                this.agri_weath.info.rain.value = this.agri_weath.input.town.GT[this.agri_weath.input.town.value].Rain;
                this.agri_weath.info.rh.value = this.agri_weath.input.town.GT[this.agri_weath.input.town.value].RH;
                this.agri_weath.info.sunrise.value = this.agri_weath.input.town.GT[this.agri_weath.input.town.value].Sunrise;
                this.agri_weath.info.sunset.value = this.agri_weath.input.town.GT[this.agri_weath.input.town.value].Sunset;
            
                this.getInfoAgriWeathTableHr72();
                this.getInfoAgriWeathTableWeek();
            }
        },

        //設定中央氣象屬(鄉鎮市區及作物)(72小時溫度曲線圖表)
        setInfoAgriWeathChartHr72(){

            console.log(this.agri_weath.input.town.Position3h);
            console.log(this.agri_weath.input.town.Date_3hr);
            console.log(this.agri_weath.input.town.TempArray_3hr);

            console.log(this.agri_weath.input.town.TempArray_3hr[this.agri_weath.input.town.value].C.T);
            console.log(this.agri_weath.input.town.TempArray_3hr[this.agri_weath.input.town.value].C.AT);

            const _this = window.vue._data;
            for(var i=0 ; i < this.agri_weath.input.town.Time_3hr.C.length ; i++)
            {
                var item = this.agri_weath.input.town.Time_3hr.C[i];

                item = item.replaceAll("<span style=\"color:#1a67b1;\">","");
                item = item.replaceAll("<span style=\"color:#ea1904;\">","");
                item = item.replaceAll("</span>","");
                item = item.replaceAll("<br>"," ");        
                item = item.split(" "); 
                item = item[1] + " " + item[2] + " " + item[0] + ":00"; 
                this.agri_weath.input.town.Time_3hr.C[i] = item;
            }

            window.ChartIntelligenceAgriHr72 = null;
            window.ThreadTool.Delay(function(){
        
                var points = [];
                var min = 100;
                for(var i2=0 ; i2<_this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].C.AT.length ; i2++)
                {
                    var item = _this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].C.AT[i2]; 
                    if(min > item){ min = item; }
                }

                for(var i=0 ; i<_this.agri_weath.input.town.Time_3hr.C.length ; i++)
                {
                    var point = {
                        x:_this.agri_weath.input.town.Time_3hr.C[i],
                        //y:_this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].C.T[i],
                        y:min-1,
                        marker: {
                            size: 1
                        }
                    };

                    if(Number(_this.agri_weath.input.town.Time_3hr.C[i].split(" ")[2].split(":")[0]) > 18 )
                    {
                        point.image = {};
                        point.image.path = 'https://www.cwa.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/night/' + _this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].Wx.C[i][0] + '.svg';
                    }
                    else
                    {
                        point.image = {};
                        point.image.path = 'https://www.cwa.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/day/' + _this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].Wx.C[i][0] + '.svg';
                    }  

                    if(i%3 == 0){ points.push(point); }
                }

                window.setChartIntelligenceAgriHr72("#chart_intelligence_agri_hr72",{

                    date:_this.agri_weath.input.town.Time_3hr.C,
                    t:_this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].C.T,
                    at:_this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].C.AT,
                    wx:_this.agri_weath.input.town.TempArray_3hr[_this.agri_weath.input.town.value].Wx.C,
                    points:points
                });

            },1500);
        },

        //設定中央氣象屬(鄉鎮市區及作物)(一周預報溫度曲線)(一周溫度)
        setInfoAgriWeathChartWeekT(){

            const _this = window.vue._data;
            window.ChartIntelligenceAgriWeekT = null;
            window.ThreadTool.Delay(function(){
    
                var points = [];

                for(var i=0 ; i<_this.agri_weath.input.town.Time_Week.C.length ; i++)
                {
                    var point = {
                        x:_this.agri_weath.input.town.Time_Week.C[i],
                        marker: {
                            size: 1
                        }
                    };

                    if(_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.T.H[i] != null)
                    {
                        point.y = _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.T.H[i] + 2;
                        point.image = {};
                        point.image.path = 'https://www.cwa.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/day/' + _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].Wx.C[i][0] + '.svg'; 
                    }
                    else
                    {
                        point.y = _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.T.L[i] - 2;
                        point.image = {};
                        point.image.path = 'https://www.cwa.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/night/' + _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].Wx.C[i][0] + '.svg';
                    }
                    points.push(point);
                }

                window.setChartIntelligenceAgriWeekT("#chart_intelligence_agri_week_t",{

                    date:_this.agri_weath.input.town.Time_Week.C,
                    h:_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.T.H,
                    l:_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.T.L,
                    wx:_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].Wx.C,
                    points:points
                });

            },1500);

        },

        //設定中央氣象屬(鄉鎮市區及作物)(一周預報溫度曲線)(一周體感溫度)
        setInfoAgriWeathChartWeekAT(){

            const _this = window.vue._data;
            window.ChartIntelligenceAgriWeekAT = null;
            window.ThreadTool.Delay(function(){
    
                var points = [];

                for(var i=0 ; i<_this.agri_weath.input.town.Time_Week.C.length ; i++)
                {
                    var point = {
                        x:_this.agri_weath.input.town.Time_Week.C[i],
                        marker: {
                            size: 1
                        }
                    };

                    if(_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.AT.H[i] != null)
                    {
                        point.y = _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.AT.H[i] + 2;
                        point.image = {};
                        point.image.path = 'https://www.cwa.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/day/' + _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].Wx.C[i][0] + '.svg'; 
                    }
                    else
                    {
                        point.y = _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.AT.L[i] - 2;
                        point.image = {};
                        point.image.path = 'https://www.cwa.gov.tw/V8/assets/img/weather_icons/weathers/svg_icon/night/' + _this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].Wx.C[i][0] + '.svg';
                    }
                    points.push(point);
                }

                window.setChartIntelligenceAgriWeekAT("#chart_intelligence_agri_week_at",{

                    date:_this.agri_weath.input.town.Time_Week.C,
                    h:_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.AT.H,
                    l:_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].C.AT.L,
                    wx:_this.agri_weath.input.town.TempArray_Week[_this.agri_weath.input.town.value].Wx.C,
                    points:points
                });

            },1500);

        },

    }
}
</script>
<style scoped>

</style>